import EncounterItem from './EncounterItem';

export default EncounterItem;
